import Link from 'next/link';
import React from 'react';
import { FiArrowRight } from 'react-icons/fi';

import useContact from '../../../hooks/useContact';

import styles from './contentComponents.module.css';

import Heading from '@components/Heading';

export const ContentContainer = ({ children, additionalStyles }) => (
  <div className={`${styles.container} fade fade-3`} style={additionalStyles}>
    {children}
  </div>
);

export const ContentHeading = ({ text, additionalStyles = {} }) => (
  <Heading Tag="h3" size="xs" style={additionalStyles}>
    {text}
  </Heading>
);

export const ContentSubheading = ({ text }) => (
  <p
    className={`fade fade-5 font-medium font-inter text-gray-600 dark:text-cobalt-600   ${styles.subheading}`}
  >
    {text}
  </p>
);

export const ContentLink = ({
  text,
  href = '/',
  asPath = href,
  withArrow = true,
  isNotFocusable = false,
  contactLink = false,
}) => {
  const { show: onContactClick } = useContact();

  return (
    <>
      {contactLink && (
        <button
          onClick={onContactClick}
          className={`fade fade-6 font-inter outline-none ${styles.link} text-black dark:text-blue-100`}
        >
          {text}
          {withArrow && (
            <i>
              <FiArrowRight />
            </i>
          )}
        </button>
      )}

      {!contactLink && (
        <Link href={href} as={asPath}>
          <a
            className={`fade fade-6 font-inter outline-none ${styles.link} text-black dark:text-blue-100`}
            tabIndex={isNotFocusable ? -1 : 0}
          >
            {text}
            {withArrow && (
              <i>
                <FiArrowRight />
              </i>
            )}
          </a>
        </Link>
      )}
    </>
  );
};
